import { Component } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig } from '@ngx-formly/core';
//      FormlyFieldConfig | ((field: FormlyFieldConfig) => FormlyFieldConfig);
@Component({
  selector: 'phdsoft-formly-repeat-section',
  template: `
    <h4>{{title}}</h4>
    <div *ngFor="let field of field.fieldGroup; let i = index;" class="repeat-group">

      <formly-group [field]="field" [form]="formControl" [options]="options">
      </formly-group>

      <div class="repeat-btn-delete">
       <button mat-icon-button color="warn" (click)="remove(i)" aria-label="delete">
          <mat-icon>delete</mat-icon>
       </button>
       </div>
    </div>
    <div>
      <button mat-button color="green" type="button" (click)="add()"><mat-icon>add</mat-icon>{{btnText}}</button>
    </div>
  `,
  styles: [
    `
      .repeat-group{
        border: 1px solid #485c5c;
        padding: 5px;
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
      }

      .repeat-btn-delete {
        width: 100%;
        height: 10px;
      }

      .repeat-btn-delete button {
        float: right;
        margin-top: -22px;
        }
    `
  ]
})
export class FormlyRepeatSectionComponent extends FieldArrayType {
  public get title() {
    return (this.field.fieldArray as FormlyFieldConfig).props?.title
           ?? (this.field.fieldArray as FormlyFieldConfig).templateOptions?.title
  }

  get btnText() {
    return (this.field.fieldArray as FormlyFieldConfig).props?.btnText
           ?? (this.field.fieldArray as FormlyFieldConfig).templateOptions?.btnText
  }
 }
